const ModalBody = ({bodyClassName, bodyStyle, children}) => {
  return (
    <div className={bodyClassName} style={bodyStyle}>
      {children}
    </div>
  );
};

export default ModalBody;
